/**
 * Casper-Style Add-On Bundle — Canadian site (LIVE, not an A/B test)
 * ───────────────────────────────────────────────────────────
 * Ported & expanded from main-ca `assets/onsite-test-bumper-kit-addon.js`.
 *
 * Renders a dual-card bundle directly below the Assembly Options block
 * (#bundle-options) on Front Bumper product pages:
 *   • 240-Piece Bumper Clip Kit  — +$20.00  (fixed universal variant)
 *   • Touch-Up Paint Bottle      — catalog price (resolved by make + paint code)
 *
 * One master toggle (derived state of the two item toggles) + a per-item
 * toggle each. Self-contained: keeps its own total line and never writes to
 * kit-bundle.liquid's shared #bundle-total-* / #price-display-a2c elements.
 *
 * Config is injected by snippets/casper-addon-bundle.liquid as window.__PARTIFY_BUNDLE.
 */
(function () {
	var CFG = window.__PARTIFY_BUNDLE || {};
	var LOG = "[casper-bundle]";

	function log() {
		try {
			console.log.apply(console, [LOG].concat([].slice.call(arguments)));
		} catch (e) {}
	}

	// Which add-ons can appear on THIS product:
	//  • Clip kit — only on bumpers tagged 'Bundle-Bumper-Clips' (fitment control, like CA).
	//  • Touch-up paint — only when a matching paint-bottle product exists for the make.
	var CLIP_ON = !!CFG.clipEligible && !!(CFG.kitVariantId || CFG.kitProductHandle);
	var PAINT_ON = !!CFG.paintBottleHandle;

	if (!CLIP_ON && !PAINT_ON) {
		log("neither add-on eligible for this product — not rendering");
		return;
	}

	// ── Money helpers ──────────────────────────────────────────────────────
	function formatMoney(cents) {
		var n = Number(cents) || 0;
		try {
			if (window.Shopify && typeof Shopify.formatMoney === "function") {
				return Shopify.formatMoney(Math.round(n));
			}
		} catch (e) {}
		return "$" + (n / 100).toFixed(2);
	}
	function parseMoneyToCents(text) {
		if (!text) return null;
		var num = parseFloat(String(text).replace(/[^0-9.]/g, ""));
		return isNaN(num) ? null : Math.round(num * 100);
	}

	// ── State (master is DERIVED, never an independent variable) ─────────────
	var state = {
		clip: {
			selected: false,
			variantId: CFG.kitVariantId || null,
			priceCents: Number(CFG.kitPriceCents) || 2000,
			available: true, // verified against /products/{handle}.js on mount
			image: null,
		},
		paint: {
			selected: false,
			intentOn: false, // sticky: true only while the customer actually wants Touch-Up on, independent of whether a bottle currently resolves
			priceCents: Number(CFG.paintPriceCents) || 0,
			code: null, // paint code copied from #variant-selector
			variantId: null, // exact resolved essential-kit variant
			resolved: false, // whether we attempted resolution for the current code
			resolvedForCode: null,
			matched: false,
			available: !!CFG.paintBottleHandle, // can a bottle product even be resolved?
		},
	};

	function masterOn() {
		return (CLIP_ON && state.clip.selected) || (PAINT_ON && state.paint.selected);
	}

	// ── DOM refs (filled after render) ───────────────────────────────────────
	var els = {};

	// ── Paint code helpers (reused/extended from CA getCurrentPaintCode) ──────
	function _cleanCode(raw) {
		if (!raw) return null;
		var m = String(raw)
			.trim()
			.match(/^([A-Z0-9][A-Z0-9.\-\/]{1,8})\b/i);
		var code = m ? m[1].trim().toUpperCase() : "";
		// Exclude non-codes: VIN/license prompts, and the "Unpainted" option (which must
		// never be treated as a paint code — that produced bogus "UNPAINTED" line items).
		if (!code || code === "VIN" || code === "BY" || code === "FIND") return null;
		if (code === "MATCH" || code === "SELECT") return null; // "Match by VIN" / "Select Paint Code" prompts
		if (/^UNPAINT/.test(code) || /^SINPINT/.test(code)) return null;
		return code;
	}
	function getCurrentPaintCode() {
		// 0) If the shopper picked "Unpainted", there is no paint code — and no bottle to
		// match. (The #variant-selector may still hold a stale code, so check this first.)
		const unpainted = document.getElementById("checkbox-select-unpainted");
		if (unpainted && unpainted.checked) return null;
		// 1) The paint-code dropdown, if present and populated.
		const sel = document.getElementById("variant-selector");
		if (sel) {
			const opt = sel.options[sel.selectedIndex];
			if (opt) {
				const fromData =
					(opt.dataset && (opt.dataset.paintCode || opt.dataset.code || opt.dataset.variantTitle)) || "";
				const c = _cleanCode(fromData) || _cleanCode(opt.textContent || opt.innerText);
				if (c) return c;
			}
		}
		// 2) The selected "Painted XXX" radio label (e.g. VIN-determined code).
		const radio = document.querySelector('input[name="select_paint_option"]:checked');
		if (radio && radio.id !== "checkbox-select-unpainted") {
			const lbl = radio.closest("label") ||
				document.querySelector('label[for="' + radio.id + '"]');
			let txt = lbl ? lbl.textContent : "";
			// Strip a leading "Painted"/"Pintado" word, then read the code.
			txt = txt.replace(/^\s*(painted|pintado)\s+/i, "");
			const c2 = _cleanCode(txt);
			if (c2) return c2;
		}
		return null;
	}

	// ── Touch-up bottle resolution (per make + exact Canadian paint code) ──────
	// Liquid supplies every one-option variant through product_option_value.variant,
	// which is not subject to product.variants' 250-variant cap.
	function resolveVariantByCode(code) {
		if (!code || !CFG.paintBottleHandle || !CFG.paintVariants) return null;
		const normalizedCode = String(code).trim().toUpperCase();
		const variant = CFG.paintVariants[normalizedCode];
		if (!variant || !variant[0]) return null;
		return {
			id: String(variant[0]),
			priceCents: Number(variant[1]) || null,
			available: variant[2] !== false,
		};
	}

	// Resolve the paint variant for the current code; updates state + UI.
	// (Synchronous: CA's variants come from a pre-injected config lookup, not
	// an async Storefront fetch, so there is no overlapping-call race to guard
	// against here — the token-guard part of PR #579 does not apply to CA.)
	function resolvePaint() {
		const code = getCurrentPaintCode();
		const exact = resolveVariantByCode(code);
		state.paint.code = code;
		if (exact) {
			state.paint.variantId = exact.id;
			state.paint.priceCents = exact.priceCents || state.paint.priceCents;
			state.paint.available = exact.available !== false;
			state.paint.matched = true;
		} else {
			state.paint.variantId = null;
			state.paint.available = false;
			state.paint.matched = false;
		}
		state.paint.resolved = true;
		state.paint.resolvedForCode = code || null;
		// selected always derives from sticky intent + current bottle readiness,
		// never the reverse — a temporarily-unresolved bottle greys the checkbox
		// without erasing the customer's on/off choice; once a bottle resolves
		// again it re-derives to true automatically, from whichever event ends
		// up calling resolvePaint().
		state.paint.selected = state.paint.intentOn && paintReady();
		reflectToggles();
		updateAvailabilityUI();
		updatePaintWarning();
		updateTotals();
		return Promise.resolve();
	}

	// Ensure the paint variant matches the current on-page code at add time too.
	function ensurePaintResolved() {
		if (!state.paint.selected) return Promise.resolve();
		const code = getCurrentPaintCode();
		if (state.paint.resolved && state.paint.resolvedForCode === code && state.paint.variantId) {
			return Promise.resolve();
		}
		return resolvePaint();
	}

	function updatePaintImage() {
		if (!state.paint.image || !els.wrap) return;
		var img = els.wrap.querySelector('[data-item-img="paint"]');
		if (img) {
			var src = state.paint.image;
			// Shopify image URLs accept a size suffix for a lighter thumbnail.
			img.src = src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, "_160x160$1$2");
		}
	}

	// ── Render ───────────────────────────────────────────────────────────────
	function buildMarkup() {
		var kitName = CFG.kitName || "240-Piece Bumper Clip Kit";
		var kitImg = CFG.kitImage || "";
		var paintName = CFG.paintName || "Partify Touch-Up Paint Bottle";
		var paintImg = CFG.paintImage || "";
		const placeholderImg = CFG.placeholderImage || "";

		// Only render the cards that are eligible for this product.
		var cards = [];
		if (CLIP_ON) {
			cards.push(itemHTML("clip", kitName, kitImg || placeholderImg,
				"240 OEM-grade clips &amp; fasteners. Every clip for a rattle-free install.",
				state.clip.priceCents));
		}
		if (PAINT_ON) {
			cards.push(itemHTML("paint", paintName, paintImg || placeholderImg,
				"Factory-matched touch-up bottle. Fix scratches &amp; chips later.",
				state.paint.priceCents));
		}
		var itemsHtml = cards.join('<div class="casper-bundle__plus" aria-hidden="true">+</div>');

		var defaultCents =
			(CLIP_ON ? state.clip.priceCents : 0) + (PAINT_ON ? state.paint.priceCents : 0);

		var wrap = document.createElement("div");
		wrap.className = "casper-bundle";
		wrap.setAttribute("data-casper-bundle", "");
		wrap.innerHTML = [
			'<label class="casper-bundle__header" aria-label="Add recommended extras to your order">',
			'  <input type="checkbox" class="casper-bundle__master-input" data-master aria-label="Add all extras" />',
			'  <span class="casper-bundle__track" aria-hidden="true"><span class="casper-bundle__thumb"></span></span>',
			'  <span class="casper-bundle__head-text">',
			'    <span class="casper-bundle__title">Complete your repair &amp; save</span>',
			'    <span class="casper-bundle__subtitle">Everything you need for a clean, complete install.</span>',
			"  </span>",
			'  <span class="casper-bundle__head-price" data-master-price>+' +
				formatMoney(defaultCents) +
				"</span>",
			"</label>",
			'<div class="casper-bundle__items">',
			itemsHtml,
			"</div>",
			'<p class="casper-bundle__warning" data-paint-warning hidden></p>',
			'<div class="casper-bundle__total">',
			"  <span>Total with add-ons</span>",
			'  <span data-bundle-total>' + formatMoney(getBasePriceCents()) + "</span>",
			"</div>",
		].join("");
		return wrap;
	}

	function itemHTML(key, name, img, desc, priceCents) {
		return [
			'<div class="casper-bundle__item" data-item="' + key + '">',
			'  <label class="casper-bundle__item-toggle" aria-label="Add ' + name + '">',
			'    <input type="checkbox" class="casper-bundle__item-input" data-item-input="' + key + '" />',
			'    <span class="casper-bundle__mini-track"><span class="casper-bundle__mini-thumb"></span></span>',
			"  </label>",
			'  <div class="casper-bundle__item-media"><img data-item-img="' + key + '" src="' + img + '" alt="' + name + '" loading="lazy" /></div>',
			'  <div class="casper-bundle__item-name">' + name + "</div>",
			'  <div class="casper-bundle__item-desc">' + desc + "</div>",
			key === "paint"
				? '  <a class="casper-bundle__guide-link" href="/pages/touch-up-paint-1?view=touch-up-paint-instructions#guide-bottle">How to apply <span aria-hidden="true">&rarr;</span></a>'
				: "",
			'  <div class="casper-bundle__item-price">+' + formatMoney(priceCents) + "</div>",
			'  <div class="casper-bundle__item-ship" data-item-ship="' + key + '">In stock &middot; Free shipping</div>',
			"</div>",
		].join("");
	}

	function getBasePriceCents() {
		var el = document.getElementById("price-display-a2c");
		var cents = el ? parseMoneyToCents(el.textContent) : null;
		if (cents != null) return cents;
		if (CFG.basePriceCents) return Number(CFG.basePriceCents);
		return 0;
	}

	// ── UI sync ───────────────────────────────────────────────────────────────
	function reflectToggles() {
		if (els.master) els.master.checked = masterOn();
		if (els.clipInput) els.clipInput.checked = state.clip.selected;
		if (els.paintInput) els.paintInput.checked = state.paint.selected;
		if (els.wrap) els.wrap.classList.toggle("casper-bundle--active", masterOn());
		var clipCard = els.wrap && els.wrap.querySelector('[data-item="clip"]');
		var paintCard = els.wrap && els.wrap.querySelector('[data-item="paint"]');
		if (clipCard) clipCard.classList.toggle("is-selected", state.clip.selected);
		if (paintCard) paintCard.classList.toggle("is-selected", state.paint.selected);
	}

	// The paint bottle is only selectable once an exact paint code is matched — you can't
	// add a bottle without knowing the color. (Clip kit needs no code.)
	function paintReady() {
		return state.paint.available !== false && state.paint.matched === true && !!state.paint.variantId;
	}

	// Reflect each item's selectability on its card: gray out + disable the toggle when it
	// can't be added, and swap the shipping line to a clear reason. Prevents the "toggle is
	// on but nothing adds" confusion.
	function updateAvailabilityUI() {
		if (!els.wrap) return;

		// Clip — gated purely on stock.
		(function () {
			var card = els.wrap.querySelector('[data-item="clip"]');
			var ship = els.wrap.querySelector('[data-item-ship="clip"]');
			var input = els.wrap.querySelector('[data-item-input="clip"]');
			if (!card) return;
			var avail = state.clip.available !== false;
			card.classList.toggle("is-unavailable", !avail);
			if (input) input.disabled = !avail;
			if (ship) {
				ship.classList.remove("is-prompt");
				ship.textContent = avail ? "In stock · Free shipping" : "Currently sold out";
				ship.classList.toggle("is-soldout", !avail);
			}
		})();

		// Paint — selectable only when an exact paint-code bottle is resolved.
		(function () {
			var card = els.wrap.querySelector('[data-item="paint"]');
			var ship = els.wrap.querySelector('[data-item-ship="paint"]');
			var input = els.wrap.querySelector('[data-item-input="paint"]');
			if (!card) return;
			var ready = paintReady();
			card.classList.toggle("is-unavailable", !ready);
			if (input) input.disabled = !ready;
			// Can't be selected without a code → make sure it isn't.
			if (!ready && state.paint.selected) {
				state.paint.selected = false;
				if (input) input.checked = false;
			}
			if (ship) {
				ship.classList.remove("is-soldout", "is-prompt");
				if (ready) {
					ship.textContent = "In stock · Free shipping";
				} else if (!state.paint.code) {
					ship.textContent = "Select a paint code to add";
					ship.classList.add("is-prompt");
				} else if (state.paint.matched && state.paint.available === false) {
					ship.textContent = "Currently sold out";
					ship.classList.add("is-soldout");
				} else {
					ship.textContent = "No bottle for code " + state.paint.code;
					ship.classList.add("is-soldout");
				}
			}
		})();

		// Re-sync master + total in case the paint was just auto-deselected above.
		if (els.master) els.master.checked = masterOn();
		var pc = els.wrap.querySelector('[data-item="paint"]');
		if (pc) pc.classList.toggle("is-selected", state.paint.selected);
		if (els.wrap) els.wrap.classList.toggle("casper-bundle--active", masterOn());
		updateTotals();
	}

	function updateClipImage() {
		if (!state.clip.image || !els.wrap) return;
		var img = els.wrap.querySelector('[data-item-img="clip"]');
		if (img) img.src = state.clip.image.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, "_160x160$1$2");
	}

	function updateTotals() {
		var total = getBasePriceCents();
		if (state.clip.selected) total += state.clip.priceCents;
		if (state.paint.selected) total += state.paint.priceCents;
		if (els.total) els.total.textContent = formatMoney(total);
		if (els.masterPrice) {
			// Header price = sum of selected add-ons, or (if none selected) the eligible ones.
			var addOns = (state.clip.selected ? state.clip.priceCents : 0) +
				(state.paint.selected ? state.paint.priceCents : 0);
			var eligibleSum =
				(CLIP_ON ? state.clip.priceCents : 0) + (PAINT_ON ? state.paint.priceCents : 0);
			els.masterPrice.textContent = "+" + formatMoney(addOns || eligibleSum);
		}
	}

	function updatePaintWarning() {
		if (!els.warning) return;
		const greyed = !paintReady();
		els.warning.hidden = !(PAINT_ON && greyed);
		if (els.warning.hidden) return;
		if (!state.paint.code) {
			els.warning.textContent =
				"Touch-up paint is only available on painted parts — select a paint code above to add it.";
		} else if (state.paint.matched && state.paint.available === false) {
			els.warning.textContent = "The touch-up bottle for code " + state.paint.code + " is currently sold out.";
		} else {
			els.warning.textContent = "No touch-up bottle is available for code " + state.paint.code + ".";
		}
	}

	// ── Event wiring ───────────────────────────────────────────────────────────
	function onMasterChange() {
		const turnOn = els.master.checked;
		// Only select what can actually be added: clip must be eligible (tagged) + in stock,
		// paint needs a matched code.
		state.clip.selected = turnOn && CLIP_ON && state.clip.available !== false;
		state.paint.selected = turnOn && PAINT_ON && paintReady();
		state.paint.intentOn = turnOn && PAINT_ON;
		reflectToggles();
		updatePaintWarning();
		updateTotals();
	}

	function onItemChange(key) {
		var checked = els[key + "Input"].checked;
		// Guard: clip can't be selected when sold out; paint can't be selected without a
		// resolved exact-match code (its toggle is disabled in that state anyway).
		var blocked = key === "paint" ? !paintReady() : state[key].available === false;
		if (checked && blocked) {
			els[key + "Input"].checked = false;
			state[key].selected = false;
			if (key === "paint") state.paint.intentOn = false;
			reflectToggles();
			return;
		}
		state[key].selected = checked;
		if (key === "paint") state.paint.intentOn = checked;
		reflectToggles();
		updatePaintWarning();
		updateTotals();
	}

	function bindEvents() {
		if (els.master) els.master.addEventListener("change", onMasterChange);
		if (els.clipInput) els.clipInput.addEventListener("change", function () {
			onItemChange("clip");
		});
		if (els.paintInput) els.paintInput.addEventListener("change", function () {
			onItemChange("paint");
		});

		// Paint code can change via the paint dropdown / radios / variant updates.
		document.addEventListener("change", function (e) {
			if (!e.target) return;
			if (
				e.target.id === "variant-selector" ||
				e.target.name === "select_paint_option"
			) {
				// Always re-resolve so the paint card's enabled/disabled state tracks the
				// current code — even when the paint toggle isn't selected (e.g. switching
				// to Unpainted must immediately disable the paint add-on).
				state.paint.resolved = false;
				resolvePaint();
			}
		});
		// A raw quality_type change fires before the PDP has actually rebuilt/
		// restored its paint selection — resolving against that transitional read
		// can fail to match a bottle and permanently clear the customer's Touch-Up
		// intent via paintReady()'s auto-deselect inside resolvePaint(). Wait for
		// genuine settlement, and reuse the existing restore hook to keep the
		// customer's ON intent through it (mirrors the FBT conflict-flow path).
		document.addEventListener("partify:pdp-quality-settled", function () {
			// resolvePaint() now derives `selected` from sticky intentOn + bottle
			// readiness on every call, from any caller — no branching needed here.
			state.paint.resolved = false;
			resolvePaint();
		});
		document.addEventListener("variantsUpdated", function () {
			state.paint.resolved = false;
			resolvePaint();
		});

		// Keep our self-contained total in sync with the live base price.
		var priceEl = document.getElementById("price-display-a2c");
		if (priceEl && window.MutationObserver) {
			new MutationObserver(updateTotals).observe(priceEl, {
				childList: true,
				characterData: true,
				subtree: true,
			});
		}
	}

	// ── Add to Cart intercept (CA-proven capture pattern) ────────────────────
	var _resuming = false;
	let _adding = false;

	function findAtcButtons() {
		var sels = [".add-to-cart", ".sticky-add-to-cart"];
		var out = [];
		sels.forEach(function (s) {
			document.querySelectorAll(s).forEach(function (b) {
				out.push(b);
			});
		});
		return out;
	}

	function buildAddOnItems() {
		const items = [];
		const shared = { Bundled: "Casper add-on bundle" };
		if (CLIP_ON && state.clip.selected && state.clip.variantId && state.clip.available !== false) {
			items.push({
				id: String(state.clip.variantId),
				quantity: 1,
				properties: Object.assign({}, shared),
			});
		}
		// Only add the paint bottle when the EXACT paint code is matched — never a wrong
		// color. If the code can't be resolved to a real bottle variant, skip it (the
		// warning explains why) rather than adding a placeholder.
		if (state.paint.selected && state.paint.matched === true && state.paint.variantId && state.paint.available !== false) {
			items.push({
				id: String(state.paint.variantId),
				quantity: 1,
				properties: Object.assign({ "Paint Code": state.paint.code }, shared),
			});
		}
		return items;
	}

	// Minimal hooks for callers (e.g. the FBT "This item" paint/quality sync)
	// that change the main PDP's paint/quality out from under Casper and need
	// to preserve "Touch-Up Paint was selected" intent across that change.
	// (CA has no paintVisible flag — PAINT_ON is the CA equivalent.)
	window.__partifyCasperTouchUpIsSelected = function () {
		return !!(PAINT_ON && state.paint.intentOn);
	};

	window.__partifyCasperRestoreTouchUpSelection = function () {
		if (!PAINT_ON) return Promise.resolve(false);
		state.paint.intentOn = true;
		state.paint.resolved = false;
		return resolvePaint().then(function () {
			return !!state.paint.selected;
		});
	};

	window.__partifyGetSelectedCasperAddOns = function () {
	    return ensurePaintResolved().then(buildAddOnItems);
	};

	function onAtcClick(e) {
		if (_resuming) {
			_resuming = false;
			return; // let the theme's own handler add the main product
		}
		if (!masterOn()) return; // no add-ons selected → normal flow
		if (_adding) {
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}

		// Don't orphan our add-ons: if the Assembly Options gate is visible but no
		// assembly mode is chosen, kit-bundle.liquid will block the main add. Defer
		// to it (no preventDefault) so nothing is added until assembly is selected.
		var bundleWrap = document.getElementById("bundle-options");
		if (
			bundleWrap &&
			bundleWrap.style.display !== "none" &&
			!bundleWrap.hasAttribute("data-kit-addon-replaced") &&
			!document.querySelector('input[name="bundle_mode"]:checked')
		) {
			return;
		}

		var btn = e.currentTarget;

		// Take over the click; we'll resume the native add after our add-ons land.
		e.preventDefault();
		e.stopImmediatePropagation();
		_adding = true;

		var addOne = function (item) {
			return fetch("/cart/add.js", {
				method: "POST",
				headers: { "Content-Type": "application/json", Accept: "application/json" },
				body: JSON.stringify(item),
			}).then(function (res) {
				return res.json().then(function (body) {
					return { ok: res.ok, status: res.status, body: body, item: item };
				});
			});
		};

		// Re-resolve the paint for the current code first, then add each add-on as a
		// separate request so one sold-out item (HTTP 422) can never block the others.
		ensurePaintResolved().then(function () {
			const items = buildAddOnItems();
			if (!items.length) {
				updatePaintWarning();
				return; // nothing addable; the outer finally() resumes the main add
			}
			return Promise.all(items.map(function (it) {
				return addOne(it).catch(function (err) {
					return { ok: false, error: String(err), item: it };
				});
			})).then(function (results) {
			var failed = results.filter(function (r) { return !r.ok; });
			failed.forEach(function (r) {
				log("add-on failed", r.status, (r.body && r.body.message) || r.error);
			});
			if (failed.length) {
				// Surface a non-blocking note about what couldn't be added (e.g. sold out)
				var soldOut = failed.map(function (r) {
					return String(r.variantId || r.item.id) === String(state.clip.variantId)
						? "the bumper clip kit"
						: "the touch-up paint";
				});
				showAddNote("We couldn't add " + soldOut.join(" and ") +
					" (currently unavailable). The rest of your order was added.");
			}
			});
		}).finally(function () {
			// Resume the native add of the main product. Listener passes through via _resuming.
			_adding = false;
			_resuming = true;
			btn.click();
		});
	}

	function showAddNote(msg) {
		if (!els.warning) return;
		els.warning.textContent = msg;
		els.warning.hidden = false;
	}

	function attachAtc() {
		findAtcButtons().forEach(function (btn) {
			if (btn.__casperBound) return;
			btn.__casperBound = true;
			btn.addEventListener("click", onAtcClick, true);
		});
	}

	// ── Mount ────────────────────────────────────────────────────────────────
	function injectStyles() {
		if (document.getElementById("casper-bundle-styles")) return;
		var s = document.createElement("style");
		s.id = "casper-bundle-styles";
		s.textContent = STYLES;
		document.head.appendChild(s);
	}

	function mount() {
		if (document.querySelector("[data-casper-bundle]")) return;
		injectStyles();
		var anchor = document.getElementById("bundle-options");
		var wrap = buildMarkup();

		if (anchor && anchor.parentNode) {
			anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
		} else {
			var form = document.querySelector('form[action*="/cart/add"]');
			var atcWrap = document.querySelector(".add-to-cart-button-wrapper");
			if (atcWrap && atcWrap.parentNode) {
				atcWrap.parentNode.insertBefore(wrap, atcWrap);
			} else if (form) {
				form.appendChild(wrap);
			} else {
				log("no mount anchor found — aborting");
				return;
			}
		}

		els.wrap = wrap;
		els.master = wrap.querySelector("[data-master]");
		els.masterPrice = wrap.querySelector("[data-master-price]");
		els.clipInput = wrap.querySelector('[data-item-input="clip"]');
		els.paintInput = wrap.querySelector('[data-item-input="paint"]');
		els.warning = wrap.querySelector("[data-paint-warning]");
		els.total = wrap.querySelector("[data-bundle-total]");

		// Fetch the kit product to confirm stock + image + price — only when the clip is
		// eligible for this bumper (tagged 'Bundle-Bumper-Clips'); otherwise there's no
		// clip card to populate.
		if (CLIP_ON && CFG.kitProductHandle) {
			fetch("/products/" + CFG.kitProductHandle + ".js")
				.then(function (r) {
					return r.ok ? r.json() : null;
				})
				.then(function (p) {
					if (!p || !p.variants || !p.variants[0]) return;
					var v = p.variants[0];
					if (!state.clip.variantId) state.clip.variantId = v.id;
					state.clip.priceCents = v.price || state.clip.priceCents;
					state.clip.available = v.available !== false;
					if (p.featured_image) { state.clip.image = p.featured_image; updateClipImage(); }
					if (!state.clip.available && state.clip.selected) state.clip.selected = false;
					reflectToggles();
					updateAvailabilityUI();
					updateTotals();
				})
				.catch(function () {});
		}

		// Pre-read any paint code already chosen (auto-copy on load).
		state.paint.code = getCurrentPaintCode();

		bindEvents();
		attachAtc();
		reflectToggles();
		updateAvailabilityUI();
		updateTotals();
		updatePaintWarning();

		// Paint-only setup (skip entirely when the paint card isn't shown).
		if (PAINT_ON) {
			// Resolve the touch-up bottle on load so the card shows the real photo,
			// price and availability even before the customer toggles it on.
			resolvePaint();

			// Some paint selectors update asynchronously without firing a change event. Poll
			// briefly so the displayed match and add-to-cart state stay on the current code.
			var _lastSeenCode = state.paint.code;
			var _codePolls = 0;
			var _codePoll = setInterval(function () {
				_codePolls++;
				var c = getCurrentPaintCode();
				if (c !== _lastSeenCode) {
					_lastSeenCode = c;
					state.paint.resolved = false;
					resolvePaint();
				}
				if (_codePolls >= 20) clearInterval(_codePoll); // ~10s safety cap
			}, 500);
		}

		log("mounted", { kitVariant: state.clip.variantId, paintBottle: CFG.paintBottleHandle });
	}

	// ── Styles (Casper-style dual card; ported palette from main-ca widget) ───
	var STYLES = [
		// Card shell
		".casper-bundle{box-sizing:border-box;background:#fff;border:1px solid #e3e8ef;border-radius:16px;margin:18px 0;width:100%;font-family:inherit;overflow:hidden;box-shadow:0 1px 3px rgba(16,24,40,.06);transition:border-color .2s,box-shadow .2s}",
		".casper-bundle *,.casper-bundle *::before,.casper-bundle *::after{box-sizing:border-box}",
		".casper-bundle--active{border-color:#1c3fa8;box-shadow:0 4px 18px rgba(28,63,168,.13)}",
		// Header (master toggle row)
		".casper-bundle__header{display:flex;align-items:center;gap:13px;padding:15px 18px;cursor:pointer;margin:0;background:#f8fafc;border-bottom:1px solid #eef0f4;-webkit-user-select:none;user-select:none}",
		".casper-bundle--active .casper-bundle__header{background:#eff4ff;border-bottom-color:#dbe5fb}",
		".casper-bundle__master-input,.casper-bundle__item-input{position:absolute;opacity:0;width:0;height:0;margin:0}",
		".casper-bundle__track{width:46px;height:26px;background:#cbd2dd;border-radius:999px;position:relative;flex-shrink:0;transition:background .2s}",
		".casper-bundle__thumb{width:20px;height:20px;background:#fff;border-radius:50%;position:absolute;top:3px;left:3px;transition:transform .2s;box-shadow:0 1px 3px rgba(16,24,40,.3)}",
		".casper-bundle--active .casper-bundle__track{background:#1c3fa8}",
		".casper-bundle--active .casper-bundle__thumb{transform:translateX(20px)}",
		".casper-bundle__head-text{flex:1;display:flex;flex-direction:column;gap:1px;min-width:0}",
		".casper-bundle__title{font-size:15px;font-weight:700;color:#101828;line-height:1.3;letter-spacing:-.01em}",
		".casper-bundle__subtitle{font-size:12px;color:#667085;line-height:1.4}",
		".casper-bundle__head-price{font-size:16px;font-weight:700;color:#1c3fa8;white-space:nowrap;letter-spacing:-.01em}",
		// Items row
		".casper-bundle__items{display:flex;align-items:stretch;justify-content:center;gap:10px;padding:14px}",
		".casper-bundle__item{position:relative;flex:1 1 0;min-width:0;display:flex;flex-direction:column;align-items:center;text-align:center;gap:5px;padding:18px 14px 15px;border:1px solid #eaecf0;border-radius:12px;background:#fff;transition:border-color .18s,background .18s,box-shadow .18s}",
		".casper-bundle__item:hover{border-color:#d3dbe8}",
		".casper-bundle__item.is-selected{background:#f7f9ff;border-color:#1c3fa8;box-shadow:0 0 0 1px #1c3fa8 inset}",
		".casper-bundle__item-media{width:84px;height:84px;display:flex;align-items:center;justify-content:center;background:#f9fafb;border:1px solid #f0f1f3;border-radius:10px;padding:7px;margin-bottom:2px}",
		".casper-bundle__item-media img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;mix-blend-mode:multiply}",
		".casper-bundle__item-name{font-size:13px;font-weight:600;color:#1c3fa8;line-height:1.35;letter-spacing:-.01em}",
		".casper-bundle__item-desc{font-size:11.5px;color:#667085;line-height:1.45;max-width:24ch}",
		".casper-bundle__guide-link{display:inline-flex;align-items:center;gap:4px;color:#1c3fa8;font-size:11.5px;font-weight:700;line-height:1.35;text-decoration:none}",
		".casper-bundle__guide-link:hover{text-decoration:underline;text-underline-offset:3px}",
		".casper-bundle__guide-link:focus-visible{outline:3px solid #f4c542;outline-offset:3px}",
		".casper-bundle__item-price{font-size:14px;font-weight:700;color:#101828;margin-top:3px;letter-spacing:-.01em}",
		".casper-bundle__item-ship{display:inline-flex;align-items:center;gap:5px;font-size:11px;color:#0f7a52;font-weight:600}",
		".casper-bundle__item-ship::before{content:'';width:6px;height:6px;border-radius:50%;background:#16a571;flex-shrink:0}",
		".casper-bundle__item-ship.is-soldout{color:#b42318}",
		".casper-bundle__item-ship.is-soldout::before{background:#d92d20}",
		".casper-bundle__item-ship.is-prompt{color:#8a6d1b}",
		".casper-bundle__item-ship.is-prompt::before{background:#d9a514}",
		".casper-bundle__item.is-unavailable{opacity:.55}",
		".casper-bundle__item.is-unavailable .casper-bundle__item-toggle{opacity:.4;cursor:not-allowed;pointer-events:none}",
		// Per-item mini toggle (top-right of each item)
		".casper-bundle__item-toggle{position:absolute;top:11px;right:11px;cursor:pointer;margin:0;z-index:1}",
		".casper-bundle__mini-track{display:block;width:36px;height:21px;background:#cbd2dd;border-radius:999px;position:relative;transition:background .2s}",
		".casper-bundle__mini-thumb{width:15px;height:15px;background:#fff;border-radius:50%;position:absolute;top:3px;left:3px;transition:transform .2s;box-shadow:0 1px 2px rgba(16,24,40,.3)}",
		".casper-bundle__item.is-selected .casper-bundle__mini-track{background:#1c3fa8}",
		".casper-bundle__item.is-selected .casper-bundle__mini-thumb{transform:translateX(15px)}",
		// "+" divider
		".casper-bundle__plus{flex:0 0 auto;align-self:center;display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;background:#fff;border:1px solid #e3e8ef;color:#98a2b3;font-size:15px;font-weight:400;line-height:1;box-shadow:0 1px 2px rgba(16,24,40,.06)}",
		// Warning
		".casper-bundle__warning{margin:0;padding:11px 18px;font-size:12px;color:#8a6d1b;background:#fffaf0;border-top:1px solid #f5e6c0;line-height:1.45}",
		// Total
		".casper-bundle__total{display:flex;justify-content:space-between;align-items:center;margin:0;padding:14px 18px;border-top:1px solid #eef0f4;font-size:14px;color:#475467;font-weight:500}",
		".casper-bundle__total span:last-child{font-weight:700;color:#101828;font-size:16px;letter-spacing:-.01em}",
		// Mobile
		"@media (max-width:600px){.casper-bundle__items{flex-direction:column;gap:8px}.casper-bundle__plus{margin:0 auto}}",
	].join("");

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", mount);
	} else {
		mount();
	}
})();
